import { Reveal } from "./Reveal";
import { STATS } from "./data";

export const Stats = () => (
  <section aria-label="Community impact" className="relative py-16 md:py-24 bg-brand-blue grain-overlay">
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-6">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={0.06 * i}>
            <div data-testid={i === 0 ? "stat-homes-cleaned" : undefined} className="border-l-2 border-brand-green pl-5">
              <div className="font-heading font-extrabold tracking-tight text-5xl md:text-6xl text-white">{s.value}</div>
              <div className="mt-3 text-sm md:text-base text-white/80 max-w-[11rem]">{s.label}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
